import { request } from '@/shared/api/request'

export const editProject = ({ data, params }) => {
	return request({
		method: 'POST',
		url: 'staff/editProject',
		data,
		params
	})
}
